module.exports = __webpack_public_path__ + "1d2db822a52d2576f0c984a7b534d023.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/band-peacock-s.png
// module id = 2644
// module chunks = 0